<template>
    <form class="relative"
          @submit.prevent="nextStep"
    >
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <form-input v-model="form.first_name"
                        label="First Name"
                        name="first_name"
                        id="first_name"
                        :error="getErrorFor('first_name')"
                        :required="true"
            ></form-input>

            <form-input v-model="form.last_name"
                        label="Last Name"
                        name="last_name"
                        id="last_name"
                        :error="getErrorFor('last_name')"
                        :required="true"
            ></form-input>

            <form-input v-model="form.phone"
                        type="number"
                        label="Phone"
                        name="phone"
                        id="phone"
                        :error="getErrorFor('phone')"
                        :required="true"
                        class="sm:col-span-2"
            ></form-input>

            <form-input v-model="form.address_1"
                        label="Address 1"
                        name="address_1"
                        id="address_1"
                        :error="getErrorFor('address_1')"
                        :required="true"
            ></form-input>

            <form-input v-model="form.address_2"
                        label="Address 2"
                        name="address_2"
                        id="address_2"
                        :error="getErrorFor('address_2')"
            ></form-input>

            <form-input v-model="form.town"
                        label="Town / City"
                        name="town"
                        id="town"
                        :error="getErrorFor('town')"
                        :required="true"
            ></form-input>

            <form-select v-model="form.county"
                         label="County"
                         name="county"
                         id="county"
                         :error="getErrorFor('county')"
                         :required="true"
                         :options="counties"
                         track-by="value"
            ></form-select>

            <form-input v-model="form.post_code"
                        label="Post Code"
                        name="post_code"
                        id="post_code"
                        :error="getErrorFor('post_code')"
                        :required="true"
            ></form-input>

            <form-select v-model="form.country"
                         label="County"
                         name="country"
                         id="country"
                         :error="getErrorFor('country')"
                         :required="true"
                         :options="countries"
                         track-by="value"
            ></form-select>
        </div>

        <div class="flex items-center mt-6"
             v-if="hasFulfillableItems"
        >
            <form-toggle v-model="form.delivery_same_as_billing"></form-toggle>
            <button type="button"
                    class="ml-2 focus:outline-none"
                    @click="form.delivery_same_as_billing = ! form.delivery_same_as_billing"
            >
                Use this address as my delivery address
            </button>
        </div>

        <div class="mt-8"
             v-if="! form.delivery_same_as_billing"
        >
            <h1 class="text-xl mb-6">Delivery Details</h1>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <form-input v-model="form.delivery_first_name"
                            label="First Name"
                            name="delivery_first_name"
                            id="delivery_first_name"
                            :error="getErrorFor('delivery_first_name')"

                ></form-input>

                <form-input v-model="form.delivery_last_name"
                            label="Last Name"
                            name="delivery_last_name"
                            id="delivery_last_name"
                            :error="getErrorFor('delivery_last_name')"

                ></form-input>

                <form-input v-model="form.delivery_phone"
                            type="number"
                            label="Phone"
                            name="delivery_phone"
                            id="delivery_phone"
                            :error="getErrorFor('delivery_phone')"

                            class="sm:col-span-2"
                ></form-input>

                <form-input v-model="form.delivery_address_1"
                            label="Address 1"
                            name="delivery_address_1"
                            id="delivery_address_1"
                            :error="getErrorFor('delivery_address_1')"

                ></form-input>

                <form-input v-model="form.delivery_address_2"
                            label="Address 2"
                            name="delivery_address_2"
                            id="delivery_address_2"
                            :error="getErrorFor('delivery_address_2')"
                ></form-input>

                <form-input v-model="form.delivery_town"
                            label="Town / City"
                            name="delivery_town"
                            id="delivery_town"
                            :error="getErrorFor('delivery_town')"

                ></form-input>

                <form-select v-model="form.delivery_county"
                             label="County"
                             name="delivery_county"
                             id="delivery_county"
                             :error="getErrorFor('delivery_county')"

                             :options="counties"
                             track-by="value"
                ></form-select>

                <form-input v-model="form.delivery_post_code"
                            label="Post Code"
                            name="delivery_post_code"
                            id="delivery_post_code"
                            :error="getErrorFor('delivery_post_code')"

                ></form-input>

                <form-select v-model="form.delivery_country"
                             label="County"
                             name="delivery_country"
                             id="delivery_country"
                             :error="getErrorFor('delivery_country')"

                             :options="countries"
                             track-by="value"
                ></form-select>
            </div>
        </div>

        <div class="flex justify-end mt-6">
            <form-button type="submit"
                         class="w-full sm:w-auto"
            >
                Continue
            </form-button>
        </div>

        <div class="absolute z-10 inset-0 bg-translucent-white-75 flex items-center justify-center"
             v-show="loading"
        >
            <preloader></preloader>
        </div>
    </form>
</template>

<script>
    import FormInput from "../../components/form/Input";
    import FormSelect from "../../components/form/Select";
    import FormButton from "../../components/form/public/Button";
    import FormToggle from "../../components/form/public/Toggle";
    import Preloader from "../../components/Preloader";

    import Form from "../../mixins/Form";
    import Counties from "../../mixins/Counties";
    import Countries from "../../mixins/Countries";

	export default {
        data() {
            return {
                loading: false,

                form: {
                    first_name: '',
                    last_name: '',
                    phone: '',
                    address_1: '',
                    address_2: '',
                    town: '',
                    county: 'Non UK',
                    post_code: '',
                    country: 'United Kingdom',
                    delivery_same_as_billing: true,
                    delivery_first_name: '',
                    delivery_last_name: '',
                    delivery_phone: '',
                    delivery_address_1: '',
                    delivery_address_2: '',
                    delivery_town: '',
                    delivery_county: 'Non UK',
                    delivery_post_code: '',
                    delivery_country: 'United Kingdom',
                }
            }
        },

        props: {
            hasFulfillableItems: {
                type: Boolean,
                default: false,
            }
        },

        watch: {
            'form.first_name': function (value) {
                this.form.first_name = _.upperFirst(value);
            },

            'form.last_name': function (value) {
                this.form.last_name = _.upperFirst(value);
            },

            'form.address_1': function (value) {
                this.form.address_1 = _.upperFirst(value);
            },

            'form.address_2': function (value) {
                this.form.address_2 = _.upperFirst(value);
            },

            'form.town': function (value) {
                this.form.town = _.upperFirst(value);
            },

            'form.post_code': function (value) {
                this.form.post_code = value.toUpperCase();
            }
        },

        components: { FormInput, FormSelect, FormButton, FormToggle, Preloader },

        mixins: [Form, Counties, Countries],

        methods: {
            nextStep() {
                if (this.loading) return false;

                this.loading = true;

                this.post('/checkout/billing')
                    .then(() => {
                        window.location = '/checkout/payment';
                    })
                    .catch(() => {
                        this.loading = false;
                    })
            }
        }
	}
</script>
